export const PACKAGE_IDS = {
    /**
     * Analgésie topique + pansement lourd escarre ou ulcère
     */
    PANSEMENT_ULCERE_ESCARRE: "pansementUlcereEscarre",
    /**
     * Diabétique
     */
    DIABETIQUE: "diabetic",
    /**
     * Soins postopératoires
     */
    SOINS_POSTOPERATOIRES: "soinsPostop",
    /**
     * Perfusion
     */
    PERFUSION: "packPerfusion",
    /**
     * Perfusion sur patient cancéreux ou immuno-déprimé
     */
    PERFUSION_CANCEREUX: "packPerfusion2",
};